<table class="w-full border border-gray-300 shadow-md rounded-lg">
  <thead class="bg-gray-500 text-white">
    <tr>
      <th *ngFor="let col of displayedColumns; let colIndex = index" class="px-4 py-2 text-left cursor-pointer"
        (click)="col.sortable ? onSort(col.key) : null">
        {{ col.label }}
        <span *ngIf="col.sortable && sortColumn === col.key">
          {{ sortDirection === 'asc' ? '▲' : '▼' }}
        </span>
      </th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let row of data; let rowIndex = index" [class.bg-gray-50]="rowIndex % 2 === 1"
      [class.bg-white]="rowIndex % 2 === 0" class="border-b hover:bg-gray-200">
      <td *ngFor="let col of displayedColumns; let colIndex = index" 
        class="px-4 py-2">
        <ng-container *ngIf="col.key !== 'actions'">
          {{ row[col.key] || 'N/A' }}
        </ng-container>
        <ng-container *ngIf="col.key === 'actions'">
          <ng-container *ngTemplateOutlet="actionTemplate; context: { $implicit: row }"></ng-container>
        </ng-container>
      </td>
    </tr>
    <tr *ngIf="data.length === 0">
      <td [attr.colspan]="displayedColumns.length" class="text-center py-4">No data found.</td>
    </tr>
  </tbody>
</table>